// extracted by mini-css-extract-plugin
export default {"cls1":"DJXgrm3WUkyvbzTNUCry","cls2":"Qx7NK9NyMcpPvhKrZWIJ DJXgrm3WUkyvbzTNUCry"};